import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

  *, *::before, *::after {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    body {
        background-color: rgb(28, 28, 30);
        color: rgba(255, 255, 255, .87);
        font-family: 'Poppins', sans-serif;
    }

    span[role=img] {
        color: #ffffff;
    }
`;

export default GlobalStyle;
